import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../../authorize";
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import logo from './../../img/lento_logo_transparent.png';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MaterialTable from 'material-table';
import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FlagIcon from '@material-ui/icons/Flag';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Flag: forwardRef((props, ref) => <FlagIcon {...props} ref={ref} />),
  };

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 72px)',
    padding: '24px 30px 48px',
    boxSizing: 'border-box',
    background:
      'radial-gradient(circle at 8% 0%, rgba(34, 167, 171, 0.13) 0, transparent 28%), radial-gradient(circle at 96% 4%, rgba(48, 104, 170, 0.10) 0, transparent 30%), linear-gradient(180deg, #f8fbfc 0%, #edf4f7 100%)',
    color: '#173247',
    fontFamily: '"Arial", "Helvetica", sans-serif',

    [theme.breakpoints.down('sm')]: {
      padding: '16px 14px 34px',
    },
  },

  shell: {
    width: '100%',
    maxWidth: 1680,
    margin: '0 auto',
  },

  hero: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 28,
    padding: '24px 28px',
    borderRadius: 20,
    background: 'linear-gradient(135deg, #153f5d 0%, #0d7189 58%, #18958e 100%)',
    border: '1px solid rgba(255, 255, 255, 0.20)',
    boxShadow: '0 18px 42px rgba(20, 72, 96, 0.18)',

    '&::after': {
      content: '""',
      position: 'absolute',
      width: 260,
      height: 260,
      right: -92,
      top: -132,
      borderRadius: '50%',
      border: '36px solid rgba(255, 255, 255, 0.07)',
      pointerEvents: 'none',
    },

    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      padding: '22px 20px',
    },
  },

  heroCopy: {
    position: 'relative',
    zIndex: 1,
    minWidth: 0,
  },

  eyebrow: {
    margin: 0,
    color: 'rgba(255, 255, 255, 0.72)',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
  },

  title: {
    margin: '7px 0 0',
    color: '#ffffff',
    fontSize: 34,
    lineHeight: 1.12,
    fontWeight: 850,
    letterSpacing: '-0.035em',

    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },

  subtitle: {
    margin: '9px 0 0',
    maxWidth: 720,
    color: 'rgba(255, 255, 255, 0.84)',
    fontSize: 15.5,
    lineHeight: 1.55,
  },

  heroStats: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    padding: '2px 0',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },

  statBlock: {
    minWidth: 88,
    textAlign: 'left',
  },

  statLabel: {
    display: 'block',
    color: 'rgba(255, 255, 255, 0.68)',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.09em',
    textTransform: 'uppercase',
  },

  statValue: {
    display: 'block',
    marginTop: 4,
    color: '#ffffff',
    fontSize: 20,
    lineHeight: 1.1,
    fontWeight: 850,
  },

  statDivider: {
    width: 1,
    height: 33,
    margin: '0 20px',
    background: 'rgba(255, 255, 255, 0.30)',
  },

  tableCard: {
    overflow: 'hidden',
    marginTop: 16,
    borderRadius: 18,
    border: '1px solid #d9e6eb',
    background: '#ffffff',
    boxShadow: '0 16px 38px rgba(23, 70, 94, 0.09)',
  },

  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 18,
    padding: '19px 22px',
    borderBottom: '1px solid #e3ecef',

    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      padding: '17px 16px',
    },
  },

  tableTitle: {
    margin: 0,
    color: '#173247',
    fontSize: 22,
    lineHeight: 1.2,
    fontWeight: 850,
    letterSpacing: '-0.02em',
  },

  tableHint: {
    margin: '5px 0 0',
    color: '#6d8290',
    fontSize: 14,
    lineHeight: 1.45,
  },

  clearButton: {
    flex: '0 0 auto',
    minHeight: 44,
    padding: '0 17px !important',
    borderRadius: '10px !important',
    border: '1px solid #b9d7df !important',
    color: '#17677a !important',
    background: '#f2fafb !important',
    fontSize: '14px !important',
    fontWeight: '800 !important',
    textTransform: 'none !important',
    boxShadow: 'none !important',

    '&:hover': {
      background: '#e7f5f7 !important',
      borderColor: '#8fc4cf !important',
    },
  },

  tableSurface: {
    overflowX: 'auto',

    '& .MuiPaper-root': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
      background: 'transparent !important',
    },

    '& .MuiTable-root': {
      minWidth: 1120,
    },

    '& .MuiTableCell-root': {
      padding: '13px 14px',
      borderBottom: '1px solid #edf2f4',
      color: '#294355',
      fontFamily: '"Arial", "Helvetica", sans-serif',
      fontSize: '15px',
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
    },

    '& thead tr:first-child .MuiTableCell-head': {
      background: '#f3f8fa',
      color: '#29485b',
      fontSize: '14px !important',
      fontWeight: '850 !important',
      letterSpacing: '0.01em',
      borderBottom: '1px solid #d9e6eb',
    },

    '& thead tr:nth-child(2) .MuiTableCell-head': {
      paddingTop: 9,
      paddingBottom: 10,
      background: '#fbfdfe',
      borderBottom: '1px solid #dfe9ed',
    },

    '& tbody .MuiTableRow-root': {
      transition: 'background-color 140ms ease',
    },

    '& tbody .MuiTableRow-root:nth-of-type(even)': {
      background: '#fbfdfe',
    },

    '& tbody .MuiTableRow-root:hover': {
      background: '#eef8fb !important',
    },

    '& .MuiInputBase-root': {
      minHeight: 36,
      padding: '0 9px',
      borderRadius: 8,
      background: '#ffffff',
      border: '1px solid #d6e3e8',
      color: '#294355',
      fontSize: '14px',
    },

    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      display: 'none',
    },

    '& .MuiSelect-select:focus': {
      background: 'transparent',
    },

    '& .MuiIconButton-root': {
      color: '#537180',
    },

    '& .MuiTablePagination-root': {
      color: '#405d6d',
      borderTop: '1px solid #e4ecef',
    },

    '& .MuiTablePagination-caption, & .MuiTablePagination-select': {
      fontSize: '14px',
      fontWeight: 700,
    },
  },

  caseLink: {
    display: 'inline',
    color: '#08758e',
    fontSize: 14.5,
    fontWeight: 850,
    textDecoration: 'none',
    textUnderlineOffset: 3,
    transition: 'color 140ms ease',

    '&:hover': {
      color: '#054f61',
      textDecoration: 'underline',
    },

    '&:focus': {
      outline: '2px solid rgba(15, 155, 188, 0.32)',
      outlineOffset: 3,
      borderRadius: 2,
    },
  },

  statusChip: {
    display: 'inline',
    color: '#294355',
    fontSize: 14,
    fontWeight: 850,
    lineHeight: 1.35,
    whiteSpace: 'nowrap',
  },

  statusChipDanger: {
    color: '#294355',
  },

  loadingPage: {
    position: 'fixed',
    top: 72,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: '#ffffff',
  },

  loadingLogoWrap: {
    width: 'min(680px, 62vw)',
    maxWidth: 'calc(100vw - 48px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      width: 'min(520px, 78vw)',
    },

    [theme.breakpoints.down('xs')]: {
      width: 'min(390px, 86vw)',
    },
  },

  loadingLogo: {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    background: 'transparent',
    filter: 'none',
  },

  dialogPaper: {
    width: 'min(100%, 560px)',
    borderRadius: '16px !important',
    border: '1px solid #e1e9ed',
    boxShadow: '0 22px 60px rgba(22, 61, 82, 0.20) !important',
  },

  dialogHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    color: '#8d3d38',
    fontSize: 22,
    fontWeight: 850,
  },

  dialogIcon: {
    fontSize: '28px !important',
  },

  dialogCopy: {
    color: '#4b6271 !important',
    fontSize: '16px !important',
    lineHeight: '1.55 !important',
  },

  dialogButton: {
    minHeight: 42,
    padding: '0 18px !important',
    borderRadius: '9px !important',
    fontSize: '14px !important',
    fontWeight: '800 !important',
    textTransform: 'none !important',
  },

}));

const tableStyles = makeStyles({
  root: {
    justifyContent: 'flex-end',
    gap: 10,
    padding: '14px 22px 20px',
  },
  spacing: {
    justifyContent: 'flex-end',
  },
});

const theme = createTheme({
  palette: {
    primary: { main: '#0b819d' },
  },
  typography: {
    fontFamily: '"Arial", "Helvetica", sans-serif',
    h6: { fontSize: '1.25rem', fontWeight: 800 },
  },
  overrides: {
    MuiButton: {
      root: {
        fontFamily: '"Arial", "Helvetica", sans-serif',
      },
    },
  },
});

const DeepQueryList = () => {
  const classes = useStyles();
  const tableClass = tableStyles();
  const { token, role, user, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [dataa, setData] = useState({})
  const [columnFilters, setColumnFilters] = useState({});
  let temp = [];
  const [loading, setLoading] = useState(true);
  const [tblData, setTblData] = useState([]);
  const [query, setQuery] = useState([]);
  let { surgeonid } = useParams();
  const [profile, setProfile] = useState(authBody || {role: "visitor"});
  const hasRole = (profile, roles) =>{
    return roles.includes(role);
    console.log(role);
  };

  let tableRef = useRef(MaterialTable);

const clearFilter = () => {
        
    localStorage.removeItem('columnFilters');
    localStorage.removeItem('deepSearch');
   window.location.reload();
    }

const SaveFilterData = (thing) =>{
  console.log(tableRef.current.state)
  if (tableRef.current.dataManager.filteredData <1){
    localStorage.removeItem('columnFilters');
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.state.originalData));
    // useEffect();
    //alert("Filter has returned no Results.\n\n Refreshing to Full Data SET")

   // window.location.reload();
  }
  else{
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.dataManager.filteredData));
  }
}



const grabDeepQuery=() =>{

  const fetchData = async () => {
      console.log(query);
      let qq = JSON.stringify(query);
      console.log(qq);
      let qry = await axios({
            url: `https://${api_url}/api/case_list?status=active&spec=deep`,
            method: 'post',
            headers: {
                'x-access-token' : token
            },
            data:query,
            timeout:10000,
          })
          setLoading(true)
          // setState((prevState) => ({
          //     ...prevState, data: qry.data
          //   }));
          localStorage.setItem('deepSearch',JSON.stringify(qry.data));
          window.location.reload();
          console.log(qry)
  }
    fetchData();

  
}
  // console.log(state.data)
  useEffect(() => {
      let savedFilters = JSON.parse(localStorage.getItem('columnFilters'));
      let deep = JSON.parse(localStorage.getItem('deepSearch'));
      console.log(savedFilters)
      console.log(deep)
      if (deep === null){
        deep = []
      }
      if (savedFilters || JSON.stringify(savedFilters) > 5) {

        setColumnFilters(savedFilters);
      console.log("Saved Filters are here -->");
      }
      else{ savedFilters= 0}

    ////////////////////////
    const fetchData = async () => {
      if (role.includes("admin") && savedFilters){
        setLoading(false)
        setState((prevState) => ({
          ...prevState, data: savedFilters
        }));
      }
      else if (role.includes("admin") && !savedFilters){
        const admin = await axios({
          url: `https://${api_url}/api/case_list?status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })
          console.log(admin)

        setLoading(false)
        setState((prevState) => ({
          // ...prevState, data: deep
          ...prevState, data: admin.data
        }))
        // setData([]);

      }
      else if(role.includes("hospital")){
        const hos = await axios({
          url: `https://${api_url}/api/hospital_list?for_hospital=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

          console.log(hos)
          setLoading(false)

          setState((prevState) => ({
            ...prevState, data: hos.data.active
          })) 
      }

      else if(role.includes("distributor")){
        const dis = await axios({
          url: `https://${api_url}/api/distributor_list?for_distributor=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

        console.log(dis)
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: dis.data
        }))
      }
      else{
          const res = await axios({
            url: `https://${api_url}/api/case_list?${role}=${user.Email_Address}&surgeon=${surgeonid}&status=active`,
            method: 'get',
            headers: {
              'x-access-token' : token
            }
          })
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: res.data
        }))
      }
    }
    fetchData()

  }, [setState]);

  let lookup = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ?
    {
      1: "New Order",
      2: 'MRI',
      3: 'MRI QC',
      4: 'Planning 1',
      5: 'Planning 2',
      6: 'Surgeon Approval',
      7: 'Template Design',
      8: 'G Code',
      9: 'CNC',
      10: 'Final QC',
      11: 'Shipped',
      12: 'Complete',
      13: 'Aborted'
    } :

    {
      1: hasRole(profile, ['mri_center']) ? 'Ready to Upload MRI' : 'Waiting for MRI',
      2: 'In Progress',
      'MRI':'In Progress',
      3: 'In Progress',
      "MRI_QC": 'In Progress',
      4: 'In Progress',
      'Planning_1':'In Progress',
      5: hasRole(profile, ['distributor', 'surgeon']) ? 'Surgeon Approval Ready' : 'Approval Ready',
      'Planning_2': 'Approval Ready',
      6: 'Surgeon Approved',
      'Surgeon_approval': 'Surgeon Approved',
      7: 'Surgeon Approved',
      'Template_design': 'Manufacturing',
      8: 'Surgeon Approved',
      'G_code': 'Manufacturing',
      9: 'Surgeon Approved',
      'CNC': 'Manufacturing',
      10: 'Surgeon Approved',
      'Final_QC': 'Manufacturing',
      11: 'Shipped',
      'Shipped': 'Shipped'
    }


  const getStatusLabel = (value) => {
    if (lookup[value]) {
      return lookup[value];
    }

    if (value === null || value === undefined || value === '') {
      return 'New Order';
    }

    return String(value).replace(/_/g, ' ');
  };

  const isAbortedStatus = (value) => {
    return Number(value) === 13 || String(value || '').toLowerCase().includes('abort');
  };


  const handleClose = () => {
    setState({...state, dialogFlagOpen: false});
  };

  const handleSlotClose = () => {
    setState({...state, dialogMessageOpen: false});

  }
  const handleSubmit = () => {
    axios({
      url: `https://${api_url}/api/case?case_id=${state.rowData.case_id}&update=remove_flag`,
      method: 'put',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

  const handleAssign = () => {
    axios({
      url: `https://${api_url}/api/assign_command`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

const doDate = (a) =>{

}

  const [state, setState] = useState({
    adminColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", sort: false, render:rowData => {
          return (
            <div>
            <Link className={classes.caseLink} to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '15px'
          },
          
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable:"never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name} {rowData.Patient.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },
     
      { title: 'DOS Start' , field:'Patient.Date_of_Surgery', filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '15px'
        },
            customFilterAndSearch: (filterValue, rowData) => {
            if (!filterValue) return true;
            
            const rowDate = new Date(rowData.Patient.Date_of_Surgery);
            rowDate.setHours(0, 0, 0, 0); // Clear time for accurate comparison

            if (filterValue && rowDate < new Date(filterValue)) return false;
            
            return true;
          },
        
      },
       { title: 'DOS End' , field:'Patient.Date_of_Surgery', filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '15px'
        },
            customFilterAndSearch: (filterValue, rowData) => {
            if (!filterValue) return true;
            
            const rowDate = new Date(rowData.Patient.Date_of_Surgery);
            rowDate.setHours(0, 0, 0, 0); // Clear time for accurate comparison

            if (filterValue && rowDate > new Date(filterValue)) return false;
            
            return true;
          },
              },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '15px'
        }
      },
      {
        title: 'Implant', field: 'Implant', editable: 'never',
        cellStyle: {
          fontSize: '15px'
        }
      },
      {
        title: 'Status',
        field: 'case_status',
        filtering: true,
        lookup: lookup,
        editable: 'never',
        render: rowData => (
          <span
            className={`${classes.statusChip} ${
              isAbortedStatus(rowData.case_status) ? classes.statusChipDanger : ''
            }`}
          >
            {getStatusLabel(rowData.case_status)}
          </span>
        ),
        cellStyle: {
          fontSize: '15px',
        },
      },
      // {
      //   title: 'Site', field: 'geo', filtering: 'false',
      //   lookup: {
      //             "EU": 'Houston',
      //             "US": 'Dallas',
      //             "KR": 'Korea',
      //       },
      //   emptyValue: "EU",
      // },
   
      {
        title: 'Hospital', field:'Hospital.Office_Name', editable: 'never',
        cellStyle: {
          fontSize: '15px'
        }
      },
       {
        title: 'Distributor', field:'Distributor.Office_Name', editable: 'never',
        cellStyle: {
          fontSize: '15px'
        }
      },
    ],

    columns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: true, render:rowData => {
          return (
            <div>
            <Link className={classes.caseLink} to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '15px'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      // { title: 'PO #', field:'po_number', filterting: false, editable: (row, rowData) => {
      //     return rowData && !
      //     rowData.po_number
      //   },
      //   cellStyle: {
      //     fontSize: '15px'
      //   }
      // },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },

      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '15px'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },      
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '15px'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '15px'
        }
      },
      {
        title: 'Status',
        field: 'case_status',
        filtering: 'false',
        editable: 'never',
        lookup: lookup,
        emptyValue: 'New Order',
        render: rowData => (
          <span
            className={`${classes.statusChip} ${
              isAbortedStatus(rowData.case_status) ? classes.statusChipDanger : ''
            }`}
          >
            {getStatusLabel(rowData.case_status)}
          </span>
        ),
        cellStyle: {
          fontSize: '15px',
        },
      }
    ],
    hosColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link className={classes.caseLink} to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '15px'
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '15px'
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '15px'
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '15px'
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '15px'
        }
      }
    ]
  });

    console.log(state)

  if(state.data){
    console.log(state.data)
    if(state.data.notLoggedIn){

      setAuthenticated(false);
      setAuthBody({role: 'visitor'});
      alert("You have been logged out due to inactivity. Please log in again.");
      localStorage.removeItem("columnFilters");
    }
  }

  else if (loading) {
    return (
      <div className={classes.loadingPage}>
        <div className={classes.loadingLogoWrap}>
          <img className={classes.loadingLogo} src={logo} alt="Lento Medical" />
        </div>
      </div>
    );
  }

  const recordCount = Array.isArray(state.data) ? state.data.length : 0;
  const isAdminSearch = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']);
  const tableTitle = hasRole(profile, ['hospital']) ? 'Surgery list' : 'Active cases';

  return (
    <ThemeProvider theme={theme}>
      <main className={classes.page}>
        <div className={classes.shell}>
          <section className={classes.hero}>
            <div className={classes.heroCopy}>
              <p className={classes.eyebrow}>Case search</p>
              <h1 className={classes.title}>Deep search</h1>
              <p className={classes.subtitle}>
                Narrow the active case list using the filters at the top of each column.
              </p>
            </div>

            <div className={classes.heroStats} aria-label="Search summary">
              <div className={classes.statBlock}>
                <span className={classes.statLabel}>Records</span>
                <strong className={classes.statValue}>{recordCount}</strong>
              </div>
              <span className={classes.statDivider} aria-hidden="true" />
              <div className={classes.statBlock}>
                <span className={classes.statLabel}>View</span>
                <strong className={classes.statValue}>Active</strong>
              </div>
            </div>
          </section>

          <section className={classes.tableCard}>
            <div className={classes.tableHeader}>
              <div>
                <h2 className={classes.tableTitle}>{tableTitle}</h2>
                <p className={classes.tableHint}>
                  Combine multiple column filters to find a specific group of cases.
                </p>
              </div>

              {isAdminSearch && (
                <Button
                  className={classes.clearButton}
                  onClick={clearFilter}
                  startIcon={<Clear />}
                  variant="outlined"
                >
                  Clear all filters
                </Button>
              )}
            </div>

            <div className={classes.tableSurface}>
              <MaterialTable
                tableRef={tableRef}
                title={tableTitle}
                columns={isAdminSearch
                  ? state.adminColumns
                  : hasRole(profile, ['hospital'])
                    ? state.hosColumns
                    : state.columns}
                data={state.data ? state.data : []}
                icons={tableIcons}
                onSearchChange={(value) => console.log('search changed: ' + value)}
                onFilterChange={(filters) => { setQuery(filters); }}
                onQueryChange={(value) => console.log('table changed: ' + value)}
                localization={{
                  pagination: {
                    labelDisplayedRows: '{from}-{to} of {count}',
                  },
                  toolbar: {
                    nRowsSelected: '{0} row(s) selected',
                  },
                  body: {
                    emptyDataSourceMessage: 'No active cases match these filters.',
                    filterRow: {
                      filterTooltip: 'Filter this column',
                    },
                  },
                }}
                options={{
                  actionsColumnIndex: hasRole(profile, ['super_admin', 'write_admin']) ? 9 : 1,
                  sorting: false,
                  search: false,
                  toolbar: false,
                  pageSize: 20,
                  pageSizeOptions: [10, 20, 50],
                  filtering: true,
                  showTitle: false,
                  padding: 'default',
                  headerStyle: {
                    fontSize: '14px',
                    fontWeight: 850,
                  },
                  rowStyle: {
                    fontSize: '15px',
                  },
                }}
                style={{
                  fontSize: '15px',
                  background: 'transparent',
                  boxShadow: 'none',
                }}
              />
            </div>
          </section>
        </div>
      </main>

      <Dialog
        open={state.dialogFlagOpen}
        onClose={handleClose}
        aria-labelledby="flag-dialog-title"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle id="flag-dialog-title">
          <span className={classes.dialogHeading}>
            <ErrorOutlineIcon className={classes.dialogIcon} />
            Reset flag
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogCopy}>
            Flag will reset for case {state.rowData ? state.rowData.case_id : ''}.
            {state.rowData
              ? state.rowData.case_status == 2
                ? ' Are you sure you want to reset the flag? For a rescan, open the case and use the Rescan action.'
                : ' Are you sure you want to reset the flag?'
              : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          disableSpacing
          classes={{
            root: tableClass.root,
            spacing: tableClass.spacing,
          }}
        >
          <Button
            className={classes.dialogButton}
            onClick={handleClose}
            variant="outlined"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={state.dialogMessageOpen}
        onClose={handleSlotClose}
        aria-labelledby="message-dialog-title"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle id="message-dialog-title">
          <span className={classes.dialogHeading}>
            <ErrorOutlineIcon className={classes.dialogIcon} />
            Unable to change slot
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogCopy}>
            {state.oldData ? state.oldData.case_id : null} will not change slot.{' '}
            {state.error ? state.error.replace('_', ' ') : null}.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          disableSpacing
          classes={{
            root: tableClass.root,
            spacing: tableClass.spacing,
          }}
        >
          <Button
            className={classes.dialogButton}
            onClick={handleSlotClose}
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default DeepQueryList;